import { createSlice } from "@reduxjs/toolkit";
import { getDashboard, getTodayStreakScore, getStreakScore, updateStreakMode } from './thunk';
export const initialState = {
  dashboard: [],
  todayScore: {},
  streakScore: {},
  error: {}
};

const Dashboard = createSlice({
  name: 'Dashboard',
  initialState,
  reducer: {},
  extraReducers: (builder) => {
    builder.addCase(getDashboard.fulfilled, (state, action) => {
      state.dashboard = action.payload;
    });

    builder.addCase(getDashboard.rejected, (state, action) => {
      state.error = action.payload.error || null;
    });

    builder.addCase(getTodayStreakScore.fulfilled, (state, action) => {
      // state.todayScore = action.payload;
    });

    builder.addCase(getTodayStreakScore.rejected, (state, action) => {
      state.error = action.payload.error || null;
    });

    builder.addCase(getStreakScore.fulfilled, (state, action) => {
      state.todayScore = action.payload?.TodayScore || {};
      state.streakScore = action.payload?.StreakScore || {};
    });

    builder.addCase(getStreakScore.rejected, (state, action) => {
      state.error = action.payload.error || null;
    });

    builder.addCase(updateStreakMode.fulfilled, (state, action) => {
      // state.streakScore = action.payload;
    });

    builder.addCase(updateStreakMode.rejected, (state, action) => {
      state.error = action.payload.error || null;
    });
  }
});

export default Dashboard.reducer;